<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12>
        <v-layout column v-if="shopLoad" align-center>
          <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
          <progress-q></progress-q>
        </v-layout>
        <modal-q v-if="loading"></modal-q>
        <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
      </v-flex>
      <v-flex xs12 sm12 md12 lg6 v-if="!shopLoad">
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Gestisci gli orari")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <template v-for="(item, index) in days">
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  style="border: solid thin #ddd"
                  :class="{}"
                  v-bind:key="index"
                >
                  <v-card class="elevation-0">
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 style="margin-bottom: 5px">
                          <h1>{{ getDayName(item.times[0].dayOfWeek) }}</h1>
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-switch
                                color="red lighten-3"
                                style="margin: 0"
                                :label="
                                  item.isOpen
                                    ? getString('Aperto')
                                    : getString('Chiuso')
                                "
                                v-model="item.isOpen"
                              ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-show="item.isOpen">
                              <v-switch
                                color="red lighten-3"
                                style="margin: 0"
                                :label="
                                  item.isBookable
                                    ? getString('Prenotabile')
                                    : getString('Non prenotabile')
                                "
                                v-model="item.isBookable"
                              ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-show="item.isOpen">
                              <v-switch
                                color="red lighten-3"
                                style="margin: 0"
                                :label="
                                  item.isContinue
                                    ? getString('Continuo')
                                    : getString('Non continuo')
                                "
                                v-model="item.isContinue"
                              ></v-switch>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 md8 lg6 v-show="item.isOpen">
                          <label>{{
                            getString("Indica gli orari di apertura e chiusura")
                          }}</label>
                          <v-layout row wrap>
                            <v-flex xs12 md5>
                              <v-dialog
                                v-model="item.isTimePickerOpenMorning"
                                persistent
                                lazy
                                full-width
                                width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="item.times[0].open"
                                  label="Orario di apertura"
                                  prepend-icon="access_time"
                                  @click="
                                    select(
                                      item.times[0].dayOfWeek + '-open-morning'
                                    )
                                  "
                                  readonly
                                ></v-text-field>
                                <v-time-picker
                                  v-model="item.times[0].open"
                                  actions
                                  format="24hr"
                                  header-color="#d5725b"
                                  :allowed-minutes="(v) => v % 5 == 0"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="item.isTimePickerOpenMorning = false"
                                    >Annulla</v-btn
                                  >
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="setTime(item.times[0].open)"
                                    >OK</v-btn
                                  >
                                </v-time-picker>
                              </v-dialog>
                              <v-dialog
                                v-model="item.isTimePickerCloseMorning"
                                persistent
                                lazy
                                full-width
                                width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="item.times[0].close"
                                  label="Chiusura mattina"
                                  prepend-icon="access_time"
                                  @click="
                                    select(
                                      item.times[0].dayOfWeek + '-close-morning'
                                    )
                                  "
                                  readonly
                                ></v-text-field>
                                <v-time-picker
                                  v-model="item.times[0].close"
                                  actions
                                  format="24hr"
                                  header-color="#d5725b"
                                  :allowed-minutes="(v) => v % 5 == 0"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="item.isTimePickerCloseMorning = false"
                                    >Annulla</v-btn
                                  >
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="setTime(item.times[0].close)"
                                    >OK</v-btn
                                  >
                                </v-time-picker>
                              </v-dialog>
                              <!-- <v-text-field
                                readonly
                                color="black"
                                v-model="item.times[0].close"
                                @click="select(item.times[0].dayOfWeek + '-close-morning')"
                                solo
                                style="width:150px;float:left"
                                :placeholder="item.isContinue ? getString('Chiusura mattina') : getString('Chiusura')"
                              ></v-text-field>-->
                            </v-flex>
                            <v-flex xs12 md5 v-show="!item.isContinue">
                              <v-dialog
                                v-model="item.isTimePickerOpenAfternoon"
                                persistent
                                lazy
                                full-width
                                width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="item.times[1].open"
                                  label="Apertura pomeriggio"
                                  prepend-icon="access_time"
                                  @click="
                                    select(
                                      item.times[0].dayOfWeek + '-open-night'
                                    )
                                  "
                                  readonly
                                ></v-text-field>
                                <v-time-picker
                                  v-model="item.times[1].open"
                                  actions
                                  format="24hr"
                                  header-color="#d5725b"
                                  :allowed-minutes="(v) => v % 5 == 0"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="item.isTimePickerOpenAfternoon = false"
                                    >Annulla</v-btn
                                  >
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="setTime(item.times[1].open)"
                                    >OK</v-btn
                                  >
                                </v-time-picker>
                              </v-dialog>
                              <v-dialog
                                v-model="item.isTimePickerCloseAfternoon"
                                persistent
                                lazy
                                full-width
                                width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="item.times[1].close"
                                  label="Orario di chiusura"
                                  prepend-icon="access_time"
                                  @click="
                                    select(
                                      item.times[0].dayOfWeek + '-close-night'
                                    )
                                  "
                                  readonly
                                ></v-text-field>
                                <v-time-picker
                                  v-model="item.times[1].close"
                                  actions
                                  format="24hr"
                                  header-color="#d5725b"
                                  :allowed-minutes="(v) => v % 5 == 0"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="item.isTimePickerCloseAfternoon = false"
                                    >Annulla</v-btn
                                  >
                                  <v-btn
                                    flat
                                    color="primary"
                                    @click="setTime(item.times[1].close)"
                                    >OK</v-btn
                                  >
                                </v-time-picker>
                              </v-dialog>
                              <!-- <v-text-field
                                readonly
                                color="black"
                                @click="select(item.times[0].dayOfWeek + '-open-night')"
                                v-model="item.times[1].open"
                                solo
                                style="width:150px;float:left;margin-right:10px"
                                :placeholder="getString('Apertura pomeriggio')"
                              ></v-text-field>-->
                              <!-- <v-text-field
                                readonly
                                color="black"
                                @click="select(item.times[0].dayOfWeek + '-close-night')"
                                v-model="item.times[1].close"
                                solo
                                style="width:150px;float:left"
                                :placeholder="getString('Chiusura sera')"
                              ></v-text-field>-->
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-flex xs12>
              <v-btn
                class="q-orange-bk q-text-whitesmoke"
                :disabled="saveTimes"
                @click="setShopTimes"
                >{{ getString("Salva") }}</v-btn
              >
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg6 v-if="!shopLoad">
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Gestisci orari eccezionali")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap style="margin-top: 25px">
              <v-flex xs12>
                <h3>{{ getString("Inserisci il giorno") }}</h3>
                <v-menu
                  ref="dp3"
                  :close-on-content-click="false"
                  v-model="dp3"
                  :nudge-right="40"
                  :return-value.sync="date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date"
                    :label="getString('Da')"
                    prepend-icon="event"
                    readonly
                    color="red lighten-2"
                  ></v-text-field>
                  <v-date-picker
                    :locale="locale"
                    :title-date-format="formatTitle"
                    show-current
                    color="red lighten-2"
                    :min="new Date().toISOString().slice(0, 10)"
                    v-model="date"
                    @input="$refs.dp3.save(date)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <label>{{
                  getString("E' ad orario continuo? (niente spacco per pranzo)")
                }}</label>
                <v-switch
                  color="red lighten-3"
                  :label="
                    overrideContinue
                      ? getString('Continuo')
                      : getString('Non continuo')
                  "
                  v-model="overrideContinue"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <label>{{
                  getString("Indica gli orari di apertura e chiusura")
                }}</label>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-dialog
                      v-model="overrideTp0"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="overrideTime0"
                        label="Orario di apertura"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-model="overrideTime0"
                        actions
                        format="24hr"
                        header-color="#d5725b"
                        :allowed-minutes="(v) => v % 5 == 0"
                      >
                        <v-spacer></v-spacer>
                       
                        <v-btn flat color="primary" @click="overrideTp0 = false"
                          >OK</v-btn
                        >
                      </v-time-picker>
                    </v-dialog>
                    <v-dialog
                      v-model="overrideTp1"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="overrideTime1"
                        label="Chiusura mattina"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-model="overrideTime1"
                        actions
                        format="24hr"
                        header-color="#d5725b"
                        :allowed-minutes="(v) => v % 5 == 0"
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="overrideTp1 = false"
                          >Annulla</v-btn
                        >
                        <v-btn flat color="primary" @click="overrideTp1 = false"
                          >OK</v-btn
                        >
                      </v-time-picker>
                    </v-dialog>
                  </v-flex>
                  <label v-show="!overrideContinue">{{
                    getString("Apertura e chiusura pomeridiani")
                  }}</label>
                  <v-flex xs12 v-show="!overrideContinue">
                    <v-dialog
                      v-model="overrideTp2"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="overrideTime2"
                        label="Apertura pomeriggio"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-model="overrideTime2"
                        actions
                        format="24hr"
                        header-color="#d5725b"
                        :allowed-minutes="(v) => v % 5 == 0"
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="overrideTp2 = false"
                          >Annulla</v-btn
                        >
                        <v-btn flat color="primary" @click="overrideTp2 = false"
                          >OK</v-btn
                        >
                      </v-time-picker>
                    </v-dialog>
                    <v-dialog
                      v-model="overrideTp3"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="overrideTime3"
                        label="Orario di chiusura"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-model="overrideTime3"
                        actions
                        format="24hr"
                        header-color="#d5725b"
                        :allowed-minutes="(v) => v % 5 == 0"
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="overrideTp3 = false"
                          >Annulla</v-btn
                        >
                        <v-btn flat color="primary" @click="overrideTp3 = false"
                          >OK</v-btn
                        >
                      </v-time-picker>
                    </v-dialog>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-btn @click="addDay" class="q-orange-bk q-text-whitesmoke">{{
                  getString("Aggiungi giorno")
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text>
            <v-data-table
              :headers="Headers"
              :items="closeDays"
              item-key="idIsBarberShopClosed"
              :rows-per-page-items="[10, 20, 30]"
              :rows-per-page-text="getString('Date per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr style="max-height: 100px; overflow: hidden">
                  <td class="text-xs-left">
                    {{ getFormattedDate(props.item.date) }}
                  </td>
                  <td class="text-xs-left">
                    {{ getFormattedTime(props.item.open, true) }}
                  </td>
                  <td class="text-xs-left">
                    {{
                      getFormattedTime(
                        props.item.close,
                        !props.item.isSingleTime
                      )
                    }}
                  </td>
                  <td class="text-xs-left">
                    {{
                      getFormattedTime(
                        props.item.openA,
                        !props.item.isSingleTime
                      )
                    }}
                  </td>
                  <td class="text-xs-left">
                    {{ getFormattedTime(props.item.closeA, true) }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="deleteShopDay(props.item)">
                      <v-icon>remove_circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import Moment from "moment";
import ModalQ from "../../utils/ModalQ";

var ut = new Utils();
export default {
  name: "ShopOpenings",
  props: ["shopID", "tab"],
  components: {
    ProgressQ,
    ModalQ,
  },
  mounted: function () {
    this.setTimes();
    this.getShopTimes();
    this.getShopDays();
  },
  computed: {
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    pwdConfirmRule: function () {
      return [
        (v) => v === this.pwd || this.getString("Le password non coincidono"),
      ];
    },
    minLenghtRule: function () {
      return [
        (v) =>
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri"),
      ];
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    urlRule: function () {
      return [(v) => ut.validateUrl(v) || this.getString("Url non valido")];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateNumber(v) || this.getString("Numero non valido"),
      ];
    },
    saveAlert: function () {
      return true;
    },
    defaultAvatar: function () {
      if (
        this.shop.imageLink === null ||
        this.shop.imageLink === "/images/shopdefault.png" ||
        this.shop.imageLink === "images/shopdefault.png"
      ) {
        return "../../../static/img/shopdefault.png";
      } else return ajax.baseUrl() + this.shop.imageLink;
    },
    Headers: function () {
      let result = [];
      let self = this;
      if (this.closeDays.length > 0) {
        let temp = [
          self.getString("Giorno:date"),
          self.getString("Ap. Mat."),
          self.getString("Ch. Mat."),
          self.getString("Ap. Pom"),
          self.getString("Ch. Pom"),
          self.getString("Rimuovi"),
        ];
        temp.forEach((element) => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: element.split(":").length > 1 ? "left" : "center",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1],
          });
        });
        return result;
      }
      return [];
    },
  },
  data: () => {
    return {
      h: null,
      loading: false,
      timeDialog: false,
      hidden: false,
      image: null,
      times: [],
      fileUploadProgress: 0,
      selected: null,
      days: [],
      closeDays: [],
      shopLoad: false,
      saveTimes: false,
      date: new Moment().format("YYYY-MM-DD"),
      dateStart: new Moment().format("YYYY-MM-DD"),
      dateEnd: new Moment().format("YYYY-MM-DD"),
      dp3: false,
      // timepicker0: false,
      // timepicker1: false,
      // timepicker2: false,
      // timepicker3: false,
      overrideTp0: false,
      overrideTp1: false,
      overrideTp2: false,
      overrideTp3: false,
      overrideTime0: "00:00",
      overrideTime1: "00:00",
      overrideTime2: "00:00",
      overrideTime3: "00:00",
      overrideContinue: true,
    };
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.getShopTimes();
        this.getShopDays();
      }
    },
  },
  methods: {
    getFormattedTime: function (t, show) {
      if (show) return new Moment("2022-01-01T" + t).format("HH:mm");
      return "";
    },
    getFormattedDate: function (d) {
      return new Moment(d).locale("it").format("dddd DD MMMM YYYY");
    },
    formatTitle: function (d) {
      var options = {
        weekday: "long",
      };
      return ut.Capitalize(new Date().toLocaleString(this.locale, options));
    },
    getDayName: function (day) {
      switch (day) {
        case 0:
          return this.getString("Domenica");
        case 1:
          return this.getString("Lunedì");
        case 2:
          return this.getString("Martedì");
        case 3:
          return this.getString("Mercoledì");
        case 4:
          return this.getString("Giovedì");
        case 5:
          return this.getString("Venerdì");
        case 6:
          return this.getString("Sabato");
      }
    },
    select: function (item) {
      this.selected = item;
      //this.timeDialog = true;
    },
    setTime: function (item) {
      //this.timeDialog = false;
      // this.timepicker0 = false;
      // this.timepicker1 = false;
      // this.timepicker2 = false;
      // this.timepicker3 = false;
      let temp = this.selected;
      var day = temp.split("-")[0];
      this.days[day].isTimePickerOpenMorning = false
      this.days[day].isTimePickerCloseMorning = false
      this.days[day].isTimePickerOpenAfternoon = false
      this.days[day].isTimePickerCloseAfternoon = false
      if (temp === day + "-open-morning") {
        this.days[day].times[0].open = item;
      }
      if (temp === day + "-close-morning") {
        this.days[day].times[0].close = item;
      }
      if (temp === day + "-open-night") {
        this.days[day].times[1].open = item;
      }
      if (temp === day + "-close-night") {
        this.days[day].times[1].close = item;
      }
      console.log(day)
      console.log(this.days[day].times)
    },
    setTimes: function () {
      this.times = [];
      for (let index = 0; index < 1440; index += 5) {
        let tempHour = Math.floor(index / 60);
        let tempMin = index % 60;
        this.times.push(
          ut.NumberWith0(tempHour) + ":" + ut.NumberWith0(tempMin)
        );
      }
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getShopDays: function () {
      let self = this;
      this.shopLoad = true;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/overridedays",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.closeDays = response.data.data;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    addDay: function () {
      let self = this;
      if (self.shopID > 0) {
        if (self.overrideContinue) {
          self.overrideTime2 = self.overrideTime0;
          self.overrideTime3 = self.overrideTime1;
        }
        const okmorning =
          Number.parseInt(self.overrideTime0.split(":")[0]) <=
          Number.parseInt(self.overrideTime1.split(":")[0]);
        const okafternoon =
          Number.parseInt(self.overrideTime2.split(":")[0]) <=
          Number.parseInt(self.overrideTime3.split(":")[0]);
        const okBetween =
          Number.parseInt(self.overrideTime1.split(":")[0]) <=
            Number.parseInt(self.overrideTime2.split(":")[0]) ||
          self.overrideContinue;
        if (!okmorning || !okafternoon || !okBetween) {
          self.$emit("siteAlert", self.getString("Orari incongruenti"));
          return;
        }
        ajax.axios
          .post(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/timeoverride",
            {
              IdOpened: 0,
              Close: self.overrideTime1,
              Open: self.overrideTime0,
              OpenA: self.overrideTime2,
              CloseA: self.overrideTime3,
              Date: self.date,
              ReferenceBarberShop: 0,
            },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.closeDays.push(response.data.data);
            self.$emit("siteAlertSuccess", self.getString("Giorno aggiunto"));
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },

    deleteShopDay: function (item) {
      let self = this;
      this.loading = true;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/timeoverride/" +
              item.idOpened,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            let temp = [];
            self.$emit("siteAlertSuccess", response.data.data);
            for (let index = 0; index < self.closeDays.length; index++) {
              if (self.closeDays[index].idOpened !== item.idOpened) {
                temp.push(self.closeDays[index]);
              }
            }
            self.closeDays = temp;
            self.loading = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.loading = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    getShopTimes: function () {
      let self = this;
      this.shopLoad = true;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/opentimes",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            let temp = response.data.data;
            self.days = [];
            self.shopLoad = false;
            temp.forEach((element) => {
              let t = [];
              t[0] = element[0];
              t[1] = element[1];
              t[0].open = new Moment(element[0].open, "HH:mm:ss").format(
                "HH:mm"
              );
              t[0].close = new Moment(element[0].close, "HH:mm:ss").format(
                "HH:mm"
              );
              t[1].open = new Moment(element[1].open, "HH:mm:ss").format(
                "HH:mm"
              );
              t[1].close = new Moment(element[1].close, "HH:mm:ss").format(
                "HH:mm"
              );
              self.days.push({
              isTimePickerOpenMorning: false,
              isTimePickerCloseMorning: false,
              isTimePickerOpenAfternoon: false,
              isTimePickerCloseAfternoon: false,
                times: t,
                isOpen:
                  t[0].open !== "00:00" ||
                  t[0].close !== "00:00" ||
                  t[1].open !== "00:00" ||
                  t[1].close !== "00:00",
                isContinue:
                  element[0].open === element[1].open &&
                  element[0].close === element[1].close,
                isBookable: element[0].isBookable,
              });
            });
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    setShopTimes: function () {
      if (this.saveAlert) {
        let self = this;
        this.saveTimes = true;
        let data = this.days;
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/opentimes",
            data,
            {
              headers: {
                Authorization: "Bearer " + self.$store.getters.token,
              },
              onUploadProgress: function (progressEvent) {
                let p = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
                self.fileUploadProgress = p;
              }.bind(this),
              withCredentials: false,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data);
            self.saveTimes = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.saveTimes = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      } else {
        this.$emit("siteAlert", this.getString("Nessuna modifica richiesta"));
      }
    },
  },
};
</script>

<style scoped>
.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: bisque;
  }
  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopOpenings.vue